import { Button } from "@faire/web--source/slate/Button";
import { Column } from "@faire/web--source/slate/Layout";
import { Spacer } from "@faire/web--source/slate/spacing";
import { Typography } from "@faire/web--source/slate/Typography";
import { StrictLocalMsg } from "@faire/web--source/ui/lib/localization";
import brandPortalIntegrations from "@faire/web-api--source/routes/www/brand-portal/integrations";
import React, { JSX } from "react";

import { Bold } from "../common/Bold";
import { LiItem } from "../common/LiItem";

export const AboutIntegrationsIA = () => {
  return (
    <Column>
      <Typography>
        <StrictLocalMsg
          defaultMessage="We offer several integrations to help you connect Faire with the software you use to run your business, including <BoldFormatting>Shopify</BoldFormatting>, <BoldFormatting>ShipStation</BoldFormatting>, <BoldFormatting>WooCommerce</BoldFormatting>, <BoldFormatting>PrestaShop</BoldFormatting>, and more."
          values={{
            BoldFormatting,
          }}
          description={{
            text: "Introduction to integrations",
          }}
        />
      </Typography>
      <Spacer height="1x" />
      <Typography>
        <StrictLocalMsg
          defaultMessage="We’ve partnered with Shopify to launch our official <BoldFormatting>Faire: Sell Wholesale</BoldFormatting> app, an upgraded version of our existing brand integration. This Shopify sales channel app lets you automatically sync information like inventory, fulfillment, and catalog details between Faire and Shopify."
          values={{
            BoldFormatting,
          }}
          description={{
            text: "Details about Shopify integration",
          }}
        />
      </Typography>
      <Spacer height="1x" />
      <Typography>
        <StrictLocalMsg
          defaultMessage="Key features of the Shopify sales channel app include:"
          description={{
            text: "Header for key features",
          }}
        />
      </Typography>
      <Spacer height="1x" />
      <ol>
        <LiItem step={1}>
          <Typography>
            <StrictLocalMsg
              defaultMessage="<BoldFormatting>Catalog Import:</BoldFormatting> Easily import new products from Shopify to Faire, eliminating the need for manual linesheet uploads"
              values={{
                BoldFormatting,
              }}
              description={{
                text: "Feature 1",
              }}
            />
          </Typography>
        </LiItem>
        <Spacer height="1x" />
        <LiItem step={2}>
          <Typography>
            <StrictLocalMsg
              defaultMessage="<BoldFormatting>Inventory Sync:</BoldFormatting> Keep your Faire inventory up to date with real-time updates from Shopify"
              values={{
                BoldFormatting,
              }}
              description={{
                text: "Feature 2",
              }}
            />
          </Typography>
        </LiItem>
        <Spacer height="1x" />
        <LiItem step={3}>
          <Typography>
            <StrictLocalMsg
              defaultMessage="<BoldFormatting>Order Sync:</BoldFormatting> Sync orders from Faire to Shopify for streamlined order fulfillment and reporting"
              values={{
                BoldFormatting,
              }}
              description={{
                text: "Feature 3",
              }}
            />
          </Typography>
        </LiItem>
        <Spacer height="1x" />
        <LiItem step={4}>
          <Typography>
            <StrictLocalMsg
              defaultMessage="<BoldFormatting>Price Sync:</BoldFormatting> Ensure your product prices on Faire are current by syncing them from Shopify"
              values={{
                BoldFormatting,
              }}
              description={{
                text: "Feature 4",
              }}
            />
          </Typography>
        </LiItem>
      </ol>
      <Spacer height="1x" />
      <Typography>
        <StrictLocalMsg
          defaultMessage="To link an integration to your Faire account, navigate to the <LinkFormatting>Integrations</LinkFormatting> page under <BoldFormatting>Settings</BoldFormatting> and select the direct integration or middleware partner you’d like to use."
          values={{
            LinkFormatting: IntegrationsLinkFormatting,
            BoldFormatting,
          }}
          description={{
            text: "Instructions to link integration",
          }}
        />
      </Typography>
    </Column>
  );
};

const IntegrationsLinkFormatting = (chunks: JSX.Element) => (
  <Button variant="tertiary" linkTo={brandPortalIntegrations()} target="_blank">
    <Bold>{chunks}</Bold>
  </Button>
);

const BoldFormatting = (chunks: JSX.Element) => <Bold>{chunks}</Bold>;
